import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import swal from 'sweetalert2'

import { digObject } from '@domain-group/javascript-utils'

import {
  Button,
  Form,
  ModalContext,
  SidebarModal,
} from '@domain-group/suit-theme'

import useUser from '@hooks/useUser'

const confirmGenerateToken = (generateAuthToken, authTokenPayload) => {
  swal
    .fire({
      confirmButtonColor: '#43AC6A',
      confirmButtonText: 'Yes, generate it.',
      icon: 'warning',
      showCancelButton: true,
      text: 'Are you sure? This will replace the existing authentication token.',
      title: 'Generate Token?',
    })
    .then(({ value }) => {
      if (value){
        generateAuthToken(authTokenPayload)
      }
    })
}

const GenerateAuthTokenModal = (props) => {
  const { callbacks, modalKey, showModal } = props
  const { generateAuthToken, closeModal } = callbacks

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const { user: initUser } = digObject(modalData, modalKey, {})

  const {
    callbacks: { generateUserAuthenticationToken: generateFn },
    updating,
    user: {
      authentication_token,
    },
  } = useUser(initUser)

  const authTokenPayload = {
    callbacks: {
      action: generateFn,
      afterAction: closeModal,
    },
    toastText: 'Authentication Token Generated',
  }

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={modalKey} showModal={showModal} size="small">
      <SidebarModal.Header
        callbacks={callbacks}
        title="Authentication"
        titleSecondLine="Token"
      />

      <SidebarModal.Content>
        <Form.Field label="Authentication Token">
          <input
            disabled
            name="authentication_token"
            type="text"
            value={authentication_token}
          />
        </Form.Field>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          loading={updating}
          onClick={() => (authentication_token
            ? confirmGenerateToken(generateAuthToken, authTokenPayload)
            : generateAuthToken(authTokenPayload)
          )}
          size="large"
        >
          {authentication_token ? 'Yes, Generate' : 'Generate Token'}
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

GenerateAuthTokenModal.propTypes = {
  callbacks: PropTypes.object.isRequired,
  modalKey: PropTypes.string,
  showModal: PropTypes.bool,
}

GenerateAuthTokenModal.defaultProps = {
  modalKey: 'GenerateAuthTokenModal',
}

const LazyLoadedModal = props => (
  <SidebarModal.RenderController {...props}>
    <GenerateAuthTokenModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
